module.exports = __webpack_public_path__ + "e75ae80a8195e00f9fbb7e080635a6d7.png";